import React from 'react';

function ApartmentTenantComponent(props) {
    const splitNumber = (number) => {
        if (!!number) {
            var newNumber = number.replace(/\D/g, '');
            return newNumber.replace(/(.{2})/g, '$1 ').trim();
        }
        return '';
    };

    var phone = splitNumber(props.apartmentTenant.tenant.phone);
    
    return <tbody>
    <tr className={props.warning}>
        <td onClick={() => props.toggleShowInfo()} >{props.apartmentTenant && props.apartmentTenant.tenant.firstname} {props.apartmentTenant && props.apartmentTenant.tenant.lastname}</td>
        <td onClick={() => props.toggleShowInfo()} >{props.apartmentTenant && phone}</td>

        <td >{props.apartmentTenant != null ? <a href={"mailto:" + (props.apartmentTenant.tenant.email != null ? props.apartmentTenant.tenant.email : "no@email.com") + "?Subject=Kontakt"} target="_top">{props.apartmentTenant && props.apartmentTenant.tenant.email}</a> : ""}</td>
    </tr>
</tbody>;
}
export default ApartmentTenantComponent;